import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '../../configuration/setup/store';
import type { AccountInfo } from '../api/assetAdministrationBackendCodec.ts';

export interface RentalCompany {
    accountId: string;
}

export interface AppState {
    sessionExpiredAcknowledged: boolean;
    isDeletePending: boolean;
    rentalCompanies: RentalCompany[];
    accounts: AccountInfo[];
}

const initialState: AppState = {
    sessionExpiredAcknowledged: false,
    isDeletePending: false,
    rentalCompanies: [],
    accounts: [],
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        hideSessionExpiredDialog: state => {
            state.sessionExpiredAcknowledged = true;
        },
        setIsDeletePending: (state, action: PayloadAction<boolean>) => {
            state.isDeletePending = action.payload;
        },
        setRentalCompanies: (state, action: PayloadAction<RentalCompany[]>) => {
            state.rentalCompanies = action.payload;
        },
        setAccounts: (state, action: PayloadAction<AccountInfo[]>) => {
            state.accounts = action.payload;
        },
    },
});

export const { hideSessionExpiredDialog, setIsDeletePending, setRentalCompanies, setAccounts } = appSlice.actions;

export const getSessionExpiredAcknowledged = (state: RootState) => state.app.sessionExpiredAcknowledged;
export const getIsDeletePending = (state: RootState) => state.app.isDeletePending;
export const getRentalCompanies = (state: RootState) => state.app.rentalCompanies;
export const getAccounts = (state: RootState) => state.app.accounts;

export default appSlice.reducer;
